import { api } from './api'

export interface CrispIntegration {
  id: string
  user_id: string
  chatbot_id: string
  chatbot_name: string
  website_id: string
  is_active: boolean
  auto_respond: boolean
  confidence_threshold: number
  auto_handoff_on_low_confidence: boolean
  created_at: string
  updated_at: string
  last_webhook_at: string | null
  messages_received: number
  messages_sent: number
  handoffs_triggered: number
  webhook_url: string
}

export interface CreateCrispIntegrationRequest {
  chatbot_id: string
  website_id: string
  identifier: string
  key: string
  auto_respond?: boolean
  confidence_threshold?: number
  auto_handoff_on_low_confidence?: boolean
}

export interface UpdateCrispIntegrationRequest {
  is_active?: boolean
  auto_respond?: boolean
  confidence_threshold?: number
  auto_handoff_on_low_confidence?: boolean
}

export const integrationsService = {
  // Crisp integrations
  async listCrispIntegrations(): Promise<CrispIntegration[]> {
    const { data } = await api.get<CrispIntegration[]>('/integrations/crisp')
    return data
  },

  async getCrispIntegration(integrationId: string): Promise<CrispIntegration> {
    const { data } = await api.get<CrispIntegration>(`/integrations/crisp/${integrationId}`)
    return data
  },

  async createCrispIntegration(body: CreateCrispIntegrationRequest): Promise<CrispIntegration> {
    const { data } = await api.post<CrispIntegration>('/integrations/crisp', body)
    return data
  },

  async updateCrispIntegration(
    integrationId: string,
    body: UpdateCrispIntegrationRequest
  ): Promise<CrispIntegration> {
    const { data } = await api.put<CrispIntegration>(`/integrations/crisp/${integrationId}`, body)
    return data
  },

  async deleteCrispIntegration(integrationId: string): Promise<void> {
    await api.delete(`/integrations/crisp/${integrationId}`)
  },
}
